import { Editor, Node, mergeAttributes } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';
import { MAX_FILE_SIZE_BYTE, imageFileResizer } from '../../../helper/ImageResizer';
import { addNotification } from '../../../notification/Notificationstore';
import { get } from "svelte/store";
import { _ } from "svelte-i18n";
import { getAttachmentLink, getImageAttachmentUploadLink } from '../../../api/EnzianApi';
function createButton(iconName) {
    const button = document.createElement("button");
    const tinySvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    tinySvg.classList.add("w-full", "h-full", "fill-current");
    tinySvg.setAttribute('viewBox', '0 0 512 512');
    const tinySvgPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
    tinySvg.append(tinySvgPath);
    switch (iconName) {
        case "smaller":
            tinySvgPath.setAttribute("d", "M54.63 502.6L176 381.3V432c0 17.69 14.31 32 32 32s32-14.31 32-32v-128c0-4.164-.8477-8.312-2.465-12.22C234.3 283.9 228.1 277.7 220.2 274.5C216.3 272.8 212.2 272 208 272h-128c-17.69 0-32 14.31-32 32s14.31 32 32 32h50.75l-121.4 121.4c-12.5 12.5-12.5 32.75 0 45.25S42.13 515.1 54.63 502.6zM274.5 220.2c3.242 7.84 9.479 14.08 17.32 17.32C295.7 239.2 299.8 240 304 240h128c17.69 0 32-14.31 32-32s-14.31-32-32-32h-50.75l121.4-121.4c12.5-12.5 12.5-32.75 0-45.25c-12.49-12.49-32.74-12.51-45.25 0L336 130.8V80c0-17.69-14.31-32-32-32s-32 14.31-32 32v127.1C272 212.2 272.8 216.3 274.5 220.2z");
            break;
        case "bigger":
            tinySvgPath.setAttribute("d", "M208 281.4c-12.5-12.5-32.76-12.5-45.26-.002l-78.06 78.07l-30.06-30.06c-6.125-6.125-14.31-9.367-22.63-9.367c-4.125 0-8.279 .7891-12.25 2.43c-11.97 4.953-19.75 16.62-19.75 29.56v135.1C.0013 501.3 10.75 512 24 512h136c12.94 0 24.63-7.797 29.56-19.75c4.969-11.97 2.219-25.72-6.938-34.87l-30.06-30.06l78.06-78.07c12.5-12.49 12.5-32.75 .002-45.25L208 281.4zM487.1 0h-136c-12.94 0-24.63 7.797-29.56 19.75c-4.969 11.97-2.219 25.72 6.938 34.87l30.06 30.06l-78.06 78.07c-12.5 12.5-12.5 32.76 0 45.26l22.62 22.62c12.5 12.5 32.76 12.5 45.26 0l78.06-78.07l30.06 30.06c9.156 9.141 22.87 11.84 34.87 6.937C504.2 184.6 512 172.9 512 159.1V23.1C512 10.74 501.3 0 487.1 0z");
            break;
        case "left":
            tinySvgPath.setAttribute("d", "M264 40C277.3 40 288 50.75 288 64C288 77.25 277.3 88 264 88H24C10.75 88 0 77.25 0 64C0 50.75 10.75 40 24 40H264zM424 168C437.3 168 448 178.7 448 192C448 205.3 437.3 216 424 216H24C10.75 216 0 205.3 0 192C0 178.7 10.75 168 24 168H424zM0 320C0 306.7 10.75 296 24 296H264C277.3 296 288 306.7 288 320C288 333.3 277.3 344 264 344H24C10.75 344 0 333.3 0 320zM424 424C437.3 424 448 434.7 448 448C448 461.3 437.3 472 424 472H24C10.75 472 0 461.3 0 448C0 434.7 10.75 424 24 424H424z");
            break;
        case "middle":
            tinySvgPath.setAttribute("d", "M328 40C341.3 40 352 50.75 352 64C352 77.25 341.3 88 328 88H120C106.7 88 96 77.25 96 64C96 50.75 106.7 40 120 40H328zM424 168C437.3 168 448 178.7 448 192C448 205.3 437.3 216 424 216H24C10.75 216 0 205.3 0 192C0 178.7 10.75 168 24 168H424zM96 320C96 306.7 106.7 296 120 296H328C341.3 296 352 306.7 352 320C352 333.3 341.3 344 328 344H120C106.7 344 96 333.3 96 320zM424 424C437.3 424 448 434.7 448 448C448 461.3 437.3 472 424 472H24C10.75 472 0 461.3 0 448C0 434.7 10.75 424 24 424H424z");
            break;
        case "right":
            tinySvgPath.setAttribute("d", "M424 40C437.3 40 448 50.75 448 64C448 77.25 437.3 88 424 88H184C170.7 88 160 77.25 160 64C160 50.75 170.7 40 184 40H424zM424 168C437.3 168 448 178.7 448 192C448 205.3 437.3 216 424 216H24C10.75 216 0 205.3 0 192C0 178.7 10.75 168 24 168H424zM424 344H184C170.7 344 160 333.3 160 320C160 306.7 170.7 296 184 296H424C437.3 296 448 306.7 448 320C448 333.3 437.3 344 424 344zM424 424C437.3 424 448 434.7 448 448C448 461.3 437.3 472 424 472H24C10.75 472 0 461.3 0 448C0 434.7 10.75 424 24 424H424z");
            break;
    }
    button.append(tinySvg);
    button.classList.add("icon-button");
    return button;
}
function getFilesFromClipboardEvent(e) {
    let items = e.clipboardData?.items;
    const files = [];
    if (items) {
        for (let i = 0; i < items.length; i++) {
            const file = items[i].getAsFile();
            if (!file)
                continue;
            files.push(file);
        }
    }
    return files;
}
function handleImageDrop(editor, file, useCase) {
    imageFileResizer(file, useCase, (file) => {
        uploadImage(editor, file);
    });
}
export function handleImageIconClicked(editor, useCase) {
    var input = document.createElement("input");
    input.type = "file";
    input.classList.add("hidden");
    input.accept = ".jpeg,.jpg,.png";
    input.addEventListener("change", (e) => {
        let element = e.target;
        if (!element?.files) {
            document.body.removeChild(input);
            return;
        }
        // getting a hold of the file reference
        var file = element.files[0];
        //Pass the file to the drop logic
        handleImageDrop(editor, file, useCase);
        document.body.removeChild(input);
    });
    input.addEventListener('cancel', (_) => {
        document.body.removeChild(input);
    });
    //iOS fuck shit want's the element to be attached to the body. But only for the camera.
    document.body.appendChild(input);
    input.click();
}
async function uploadImage(editor, fileToUpload) {
    //Check if we go over the limit
    if (fileToUpload.size > MAX_FILE_SIZE_BYTE) {
        addNotification({
            type: "error",
            message: get(_)("documentview.position_edit.image_edit.err_image_to_big"),
        });
        return;
    }
    const imgBitmap = await createImageBitmap(fileToUpload);
    const uploadLink = await getImageAttachmentUploadLink();
    let formData = new FormData();
    // add all entries from uploadLink to formData
    for (let key in uploadLink.dataMap) {
        formData.append(key, uploadLink.dataMap[key]);
    }
    formData.append("file", fileToUpload);
    //POST the image
    let response = await fetch(uploadLink.url, {
        method: "POST",
        body: formData,
    });
    if (!response.ok) {
        addNotification({
            type: "error",
            message: get(_)("documentview.position_edit.image_edit.err_upload_image"),
        });
        return;
    }
    //Get a signed link
    let signedUrl = await getAttachmentLink(uploadLink.name);
    editor
        .chain()
        .focus()
        .setImage({
        src: signedUrl.link,
        imgname: uploadLink.name,
        imgowidth: imgBitmap.width,
        imgoheight: imgBitmap.height,
    })
        .run();
}
export default Node.create({
    name: 'img', // unique name for the Node
    group: 'block',
    atom: true,
    defining: true,
    addProseMirrorPlugins() {
        const editor = this.editor;
        const options = this.options;
        return [
            new Plugin({
                key: new PluginKey('eventHandler'),
                props: {
                    handlePaste(view, event, slice) {
                        const images = getFilesFromClipboardEvent(event).filter((file) => file.type.indexOf('image') !== -1);
                        if (images.length === 0)
                            return;
                        //Upload the first image that we have
                        uploadImage(editor, images[0]);
                        event.stopPropagation();
                        event.preventDefault();
                        return;
                    },
                    handleDrop(view, event, slice, moved) {
                        if (!moved &&
                            event.dataTransfer &&
                            event.dataTransfer.files &&
                            event.dataTransfer.files[0]) {
                            let file = event.dataTransfer.files[0]; // the dropped file
                            // check valid image type under 10MB
                            if (file.type === "image/jpeg" ||
                                file.type === "image/png") {
                                handleImageDrop(editor, file, options.useCase);
                            }
                        }
                    },
                },
            }),
        ];
    },
    addAttributes() {
        return {
            imgname: {
                default: null,
            },
            imgowidth: {
                default: null
            },
            imgoheight: {
                default: null
            },
            imgwsize: {
                default: 30
            },
            src: {
                default: null
            },
            align: {
                default: null
            },
            style: {
                default: null
            },
            crossOrigin: {
                default: "anonymous"
            },
            class: {
                default: "content-img"
            }
        };
    },
    parseHTML() {
        return [
            {
                tag: 'img',
            },
        ];
    },
    renderHTML({ node, HTMLAttributes }) {
        return ['img', mergeAttributes(HTMLAttributes, node.attrs)];
    },
    addCommands() {
        return {
            setImage: options => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: options,
                });
            },
        };
    },
    addNodeView() {
        return ({ editor, node, getPos, HTMLAttributes }) => {
            const { view } = editor;
            var currentSize = HTMLAttributes["imgwsize"];
            const container = document.createElement('div');
            container.classList.add("relative");
            const img = document.createElement('img');
            img.crossOrigin = "anonymous";
            img.src = HTMLAttributes["src"];
            img.style.width = HTMLAttributes["imgwsize"] + "%";
            const align = HTMLAttributes["align"];
            if (align == "middle") {
                img.style.marginLeft = "auto";
                img.style.marginRight = "auto";
            }
            else if (align == "right") {
                img.style.marginLeft = "auto";
            }
            container.append(img);
            const imageControllBox = document.createElement("div");
            imageControllBox.classList.add("flex", "gap-2", "items-end");
            imageControllBox.style.bottom = "8px";
            imageControllBox.style.left = "8px";
            const wrapperDiv = document.createElement("div");
            if (currentSize <= 5) {
                imageControllBox.classList.add("small-controller-box");
            }
            else {
                imageControllBox.classList.remove("small-controller-box");
            }
            const slider = document.createElement("input");
            slider.type = "range";
            slider.min = "1";
            slider.max = "100";
            slider.step = "1";
            slider.value = currentSize;
            slider.classList.add("slider");
            wrapperDiv.draggable = true;
            wrapperDiv.addEventListener("dragstart", (e) => {
                e.preventDefault();
                e.stopPropagation();
            });
            wrapperDiv.append(slider);
            wrapperDiv.append(imageControllBox);
            slider.addEventListener("change", (e) => {
                let pos = getPos();
                if (pos != undefined) {
                    currentSize = slider.value;
                    // … dispatch a transaction, for the current position in the document …
                    view.dispatch(view.state.tr.setNodeMarkup(pos, undefined, {
                        ...node.attrs,
                        "imgwsize": currentSize
                    }));
                    // … and set the focus back to the editor.
                    editor.commands.focus();
                }
            });
            const leftAlignImgButton = createButton("left");
            leftAlignImgButton.addEventListener("click", (e) => {
                let pos = getPos();
                if (pos != undefined) {
                    // … dispatch a transaction, for the current position in the document …
                    view.dispatch(view.state.tr.setNodeMarkup(pos, undefined, {
                        ...node.attrs,
                        "align": "left"
                    }));
                    // … and set the focus back to the editor.
                    editor.commands.focus();
                }
            });
            const middleAlignImgButton = createButton("middle");
            middleAlignImgButton.addEventListener("click", (e) => {
                let pos = getPos();
                if (pos != undefined) {
                    // … dispatch a transaction, for the current position in the document …
                    view.dispatch(view.state.tr.setNodeMarkup(pos, undefined, {
                        ...node.attrs,
                        "align": "middle"
                    }));
                    // … and set the focus back to the editor.
                    editor.commands.focus();
                }
            });
            const rightAlignImgButton = createButton("right");
            rightAlignImgButton.addEventListener("click", (e) => {
                let pos = getPos();
                if (pos != undefined) {
                    // … dispatch a transaction, for the current position in the document …
                    view.dispatch(view.state.tr.setNodeMarkup(pos, undefined, {
                        ...node.attrs,
                        "align": "right"
                    }));
                    // … and set the focus back to the editor.
                    editor.commands.focus();
                }
            });
            imageControllBox.append(leftAlignImgButton, middleAlignImgButton, rightAlignImgButton);
            container.append(wrapperDiv);
            return {
                dom: container
            };
        };
    }
});
